module.exports = __webpack_public_path__ + "img/saint_vincent_and_the_grenadines.74d9b09.webp";